import React from 'react'
function Hero() {
    return ( 
        <div className='container p-5'>
            <div className='row'>
                <img src='media/images/homeHero.png' alt='Hero Image' className='mb-5'/>
                <h1 className='mt-3'>
                    Invest in Everything
                </h1>
                <p>
                    Online platform to invest in stocks, mutual funds, bonds, ETFs and more. Start your investment journey with us today!
                </p>
                <button className='mt-3 p-2 mb-5 fs-5 btn btn-primary' style={{width:'30%',margin:"0 auto "}}>Signup Now</button>
            </div>
        </div>
     );
}

export default Hero;